// What Tab can reach, in DOM order (the app sets no positive tabindex, so that is the Tab order).
const TABBABLE_SELECTOR = [
  'a[href]',
  'area[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'iframe',
  'audio[controls]',
  'video[controls]',
  'summary',
  '[contenteditable]:not([contenteditable="false"])',
  '[tabindex]',
].join(',');

const tabbablesIn = (container) => Array.from(container.querySelectorAll(TABBABLE_SELECTOR))
  .filter((element) => !(Number(element.getAttribute('tabindex')) < 0) && !element.closest('[hidden], [inert]'));

/**
 * Keeps Tab and Shift+Tab inside `container`, wrapping at both ends. Focus goes to the next
 * element that accepts it, so a hidden one is skipped; a Tab another handler consumed is left alone.
 * @param {KeyboardEvent|React.KeyboardEvent} event
 * @param {HTMLElement|null} container
 */
export const trapTabKey = (event, container) => {
  if (event.key !== 'Tab' || event.defaultPrevented || !container) return;
  event.preventDefault();

  const tabbables = tabbablesIn(container);
  const count = tabbables.length;
  const current = tabbables.indexOf(document.activeElement);
  const step = event.shiftKey ? -1 : 1;
  for (let offset = 1; offset <= count; offset += 1) {
    const index = current === -1
      ? (event.shiftKey ? count - offset : offset - 1)
      : (((current + step * offset) % count) + count) % count;
    tabbables[index].focus();
    if (document.activeElement === tabbables[index]) return;
  }
  container.focus();
};
